import { i18n } from '@/i18n'

/**
 * Amounts in the rental screens. Contracts and payments carry no currency of their
 * own (web-app never stored one), so they are plain grouped numbers; a device debt
 * names its currency.
 */

const NUMBER = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 })

export function formatAmount(value: number | null | undefined): string {
  return value === null || value === undefined ? '—' : NUMBER.format(value)
}

export function formatDebt(value: number | null | undefined, currency: string | null | undefined): string {
  return value === null || value === undefined ? '—' : `${NUMBER.format(value)} ${currency ?? 'USD'}`
}

const MONEY = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

/** The short name of the credits the balance is kept in: "кр." (ru), "kr." (uz). */
export function currencyUnit(): string {
  return i18n.global.t('common.currency')
}

/** The balance, prices and top-ups in credits: "42,50 кр.", "−5,00 кр.". */
export function formatMoney(value: number | null | undefined, signed = false): string {
  if (value === null || value === undefined) {
    return '—'
  }
  const sign = value < 0 ? '−' : signed && value > 0 ? '+' : ''
  return `${sign}${MONEY.format(Math.abs(value))} ${currencyUnit()}`
}
